import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnalyticsNotesTemplate = _resolveComponent("AnalyticsNotesTemplate")!

  return (_ctx.isAccessAllowed)
    ? (_openBlock(), _createBlock(_component_AnalyticsNotesTemplate, {
        key: 0,
        defaultFilter: _ctx.defaultFilter,
        pageTitle: _ctx.pageTitle,
        exportPermissionCode: _ctx.getPermissions.export,
        readonlyPermissionCode: _ctx.getPermissions.build
      }, null, 8, ["defaultFilter", "pageTitle", "exportPermissionCode", "readonlyPermissionCode"]))
    : _createCommentVNode("", true)
}